"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _easingUtils = require("easing-utils");

var _math = require("@staccx/math");

var _Label = _interopRequireDefault(require("../../Label/Label"));

var _Input = _interopRequireDefault(require("../../Input/Input"));

var _Slider = _interopRequireDefault(require("../Slider/Slider"));

var _themeContants = require("../../../../constants/themeContants");

var _theming = require("../../../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var removeSpaces = function removeSpaces(value) {
  return value.replace(/\s/g, "");
};

var SliderKeyboardInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SliderKeyboardInput, _React$Component);

  function SliderKeyboardInput(props) {
    var _this;

    _classCallCheck(this, SliderKeyboardInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SliderKeyboardInput).call(this, props));
    _this.state = {
      isAnimatingIn: false,
      currentValue: 0,
      percentage: 0
    };
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.countUp = _this.countUp.bind(_assertThisInitialized(_this));
    _this.stopCount = _this.stopCount.bind(_assertThisInitialized(_this));
    _this.updateState = _this.updateState.bind(_assertThisInitialized(_this));
    _this.tick = 0;
    return _this;
  }

  _createClass(SliderKeyboardInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.easingFunction) {
        this.startCount();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.easingFunction) {
        this.stopCount();
      }
    }
  }, {
    key: "startCount",
    value: function startCount() {
      var _this2 = this;

      if (!this._frameId) {
        this.setState({
          isAnimatingIn: true
        }, function () {
          _this2._frameId = window.requestAnimationFrame(_this2.countUp);
        });
      }
    }
  }, {
    key: "countUp",
    value: function countUp() {
      var _this3 = this;

      // perform loop work here
      if (this.tick < this.props.animationTicks && this.props.easingFunction) {
        var t = this.props.easingFunction(this.tick / this.props.animationTicks);
        var newValue = this.props.value * t;
        this.updateState(newValue).then(function () {
          _this3._frameId = window.requestAnimationFrame(_this3.countUp);
        });
      } else {
        this.updateState(this.props.value, {
          isAnimatingIn: false
        }).then(this.stopCount);
      }

      this.tick++;
    }
  }, {
    key: "stopCount",
    value: function stopCount() {
      window.cancelAnimationFrame(this._frameId);
    }
  }, {
    key: "updateState",
    value: function updateState(value) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new Promise(function (resolve) {
        _this4.setState(_objectSpread2({
          currentValue: Math.floor(value),
          percentage: (0, _math.inverseLerp)(_this4.props.min, _this4.props.max, (0, _math.clamp)(_this4.props.min, _this4.props.max, Math.ceil(value))) * 100
        }, options), resolve);
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this5 = this;

      var value = event.target.value;
      this.updateState(parseInt(removeSpaces(value), 10)).then(function () {
        if (_this5.props.onChange) {
          _this5.props.onChange(_this5.state.currentValue);
        }
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      var _this6 = this;

      var value = event.target.value;
      var valueInt = parseInt(removeSpaces(value), 10);
      var parsed = (0, _math.clamp)(this.props.min, this.props.max, valueInt);
      this.updateState(parsed).then(function () {
        if (_this6.props.onBlur) {
          _this6.props.onBlur(_this6.state.currentValue);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          name = _this$props.name,
          min = _this$props.min,
          max = _this$props.max,
          step = _this$props.step,
          mask = _this$props.mask,
          className = _this$props.className,
          ignoreBase = _this$props.ignoreBase,
          variant = _this$props.variant,
          showLabel = _this$props.showLabel;
      var _this$state = this.state,
          currentValue = _this$state.currentValue,
          percentage = _this$state.percentage;
      return _react["default"].createElement(SliderWrapper, {
        className: className,
        variant: variant,
        ignoreBase: ignoreBase
      }, _react["default"].createElement(_Label["default"], {
        htmlFor: name,
        variant: variant
      }, label), _react["default"].createElement(SliderInput, {
        type: "text",
        name: "".concat(name, "-keyboard"),
        id: "".concat(name, "-keyboard"),
        value: currentValue,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        label: showLabel ? label : null,
        min: min,
        max: max,
        mask: mask || null,
        disabled: this.state.isAnimatingIn,
        variant: variant
      }), _react["default"].createElement(_Slider["default"], {
        percentage: percentage,
        value: currentValue,
        name: name,
        id: name,
        step: step,
        min: min,
        max: max,
        onChange: this.handleChange,
        variant: variant
      }));
    }
  }]);

  return SliderKeyboardInput;
}(_react["default"].Component);

SliderKeyboardInput.themeProps = {
  wrapper: {
    name: "SLIDER_KEYBOARD_WRAPPER",
    description: "Wrapper style",
    type: _themeContants.themePropTypes.style
  },
  input: {
    name: "SLIDER_KEYBOARD_INPUT",
    description: "Wrapper style",
    type: _themeContants.themePropTypes.style
  }
};

var SliderWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SliderKeyboardInput__SliderWrapper",
  componentId: "luggrh-0"
})(["font-family:", ";font-size:", ";", ";"], _theming.fontFamily.body, _theming.font.input, (0, _theming.applyVariants)(SliderKeyboardInput.themeProps.wrapper));

var SliderInput = (0, _styledComponents["default"])(_Input["default"]).withConfig({
  displayName: "SliderKeyboardInput__SliderInput",
  componentId: "luggrh-1"
})(["background-color:transparent;border:0;min-height:", ";max-width:100%;-moz-appearance:textfield;outline:none;&::-webkit-inner-spin-button,&::-webkit-outer-spin-button{-webkit-appearance:none;margin:0;}&:hover,&:active,&:focus,&:-moz-ui-invalid,&:invalid{outline:none;box-shadow:none;}&:disabled{color:", ";}", ";"], _theming.targetSize.normal, _theming.color.text, (0, _theming.applyVariants)(SliderKeyboardInput.themeProps.input));
SliderKeyboardInput.defaultProps = {
  animationTicks: 50,
  className: "",
  easingFunction: _easingUtils.linear,
  mask: null,
  max: 100,
  min: 0,
  onChange: null,
  step: 1,
  value: 0,
  showLabel: false
};
SliderKeyboardInput.propTypes = {
  animationTicks: _propTypes["default"].number,
  className: _propTypes["default"].string,
  easingFunction: _propTypes["default"].func,
  ignoreBase: _propTypes["default"].bool,
  label: _propTypes["default"].string.isRequired,
  mask: _propTypes["default"].func,
  max: _propTypes["default"].number,
  min: _propTypes["default"].number,
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  step: _propTypes["default"].number,
  variant: _propTypes["default"].string,
  value: _propTypes["default"].number,
  showLabel: _propTypes["default"].bool
};
var _default = SliderKeyboardInput;
exports["default"] = _default;